export const SNAP_RATIOS = {
  mid: 0.8,
  full: 1,
} as const;
export type SnapSize = keyof typeof SNAP_RATIOS;

export const CLOSE_RATIO = 0.5;
export const FLICK_VELOCITY = 0.5;
